import GridSettings from './grid-pagina-inicial';

export default GridSettings